import usePut from './api/usePut'
import type { MemberSettings } from '../models/user'
import { useUserStore } from '../../stores/user.store'
import { ApiRequestStatus } from '../models/api/api-request-status'

type RecursivePartial<T> = {
  [P in keyof T]?: T[P] extends (infer U)[]
    ? RecursivePartial<U>[]
    : T[P] extends object
      ? RecursivePartial<T[P]>
      : T[P]
}

export type UpdateMemberSettings = RecursivePartial<MemberSettings>

export const useMemeberSettings = () => {
  const { status: updateStatus, mutate } = usePut<void, { settings: UpdateMemberSettings }>(
    'member/settings',
  )

  const { loadUser } = useUserStore()

  const updateMemberSettings = async (settings: UpdateMemberSettings) => {
    await mutate({ settings })

    if (updateStatus.value === ApiRequestStatus.Success) {
      await loadUser()
    }
  }

  return {
    updateMemberSettings,
    updateStatus,
  }
}
